import React, { useEffect, useState } from 'react';

import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';


import { loadTheme } from 'office-ui-fabric-react/lib/Styling';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faMinusSquare, faPlusSquare, faSquare, faSave, faWindowRestore } from '@fortawesome/free-regular-svg-icons';

import { faHistory, faEdit, faChevronRight, faExclamation, faExclamationCircle, faExclamationTriangle, faFolderOpen, faGlobe, faTree, faUserTie, faBuilding, faUser, faUserFriends, faLaptop, faProjectDiagram } from '@fortawesome/free-solid-svg-icons';

import { initializeIcons } from '@uifabric/icons';

import { WsLoginPage } from './components/LoginPage';
import { WsWelcomePage } from './components/WelcomePage';

import { WsAppContext } from './components/AppContext';

import { WsScreenshot } from "./components/Screenshot";

import { WsDeliverPortal } from './components/Deliver/DeliverPortal';




import './App-theme.scss';




initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20210407.001/assets/icons/');

library.add(faChevronRight, faHistory, faEdit, faExclamation, faExclamationCircle, faExclamationTriangle, faFolderOpen, faGlobe, faMinusSquare, faPlusSquare, faSquare, faTree, faUserTie, faBuilding, faWindowRestore, faUser, faUserFriends, faLaptop, faProjectDiagram, faSave);




type AppProps = {
  pca: IPublicClientApplication;
};




const WsDeliverApp = ({ pca }: AppProps) => {

  // const panelContext = useContext(WsPanelContext);

  const [ loginClicked, setLoginClicked ] = useState(false);



  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  // const navigate = useNavigate();
  // const navigationClient = new CustomNavigationClient(navigate);
  // pca.setNavigationClient(navigationClient);



  const [ role, setRole ] = useState<string>('AVANADE');



  // theme

  // avanade
  // nestle
  // essex
  // hwb
  // amadeus
  // deutschebank
  // riverty
  // marksandspencer

  const [ theme, setTheme ] = useState<string>('avanade');



  useEffect(() => {
    // console.log(`theme : ${theme}`);

    if (theme === 'hwb') {

      loadTheme({
        palette: {
          themePrimary: '#c43337',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#ec8e91ff',
          themeSecondary: '#dd4348ff',
          themeDarkAlt: '#c43337', // dark green (button hover)
          themeDark: '#c43337',    // dark green
          themeDarker: '#c43337',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'nestle') {

      loadTheme({
        palette: {
          themePrimary: '#63513D',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#ec8e91ff',
          themeSecondary: '#593d1c',
          themeDarkAlt: '#63513D', // dark green (button hover)
          themeDark: '#63513D',    // dark green
          themeDarker: '#63513D',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'essex') {

      loadTheme({
        palette: {
          themePrimary: '#e40037',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#ec8e91ff',
          themeSecondary: '#dd4348ff',
          themeDarkAlt: '#e40037', // dark green (button hover)
          themeDark: '#e40037',    // dark green
          themeDarker: '#e40037',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'amadeus') {

      loadTheme({
        palette: {
          themePrimary: process.env.REACT_APP_WSP_COLOR_PRIMARY,      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#408fd4ff',
          themeSecondary: '#004578',
          themeDarkAlt: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK, // dark green (button hover)
          themeDark: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK,    // dark green
          themeDarker: '#004578',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'deutschebank') {

      loadTheme({
        palette: {
          themePrimary: '#0018A8',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#00A3E0',
          themeSecondary: '#0018A8',
          themeDarkAlt: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK, // dark green (button hover)
          themeDark: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK,    // dark green
          themeDarker: '#00205B',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'riverty') {

      loadTheme({
        palette: {
          themePrimary: '#527a42',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#86a27b',
          themeSecondary: '#527a42',
          themeDarkAlt: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK, // dark green (button hover)
          themeDark: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK,    // dark green
          themeDarker: '#37522c',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'marksandspencer') {

      loadTheme({
        palette: {
          themePrimary: '#000',            // black
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#86a27b',
          themeSecondary: '#a29161',
          themeDarkAlt: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK, // dark green (button hover)
          themeDark: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK,    // dark green
          themeDarker: '#37522c',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'hp') {

      loadTheme({
        palette: {
          themePrimary: process.env.REACT_APP_WSP_COLOR_PRIMARY,      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#71afe5',
          themeSecondary: '#2b88d8',
          themeDarkAlt: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK, // dark green (button hover)
          themeDark: process.env.REACT_APP_WSP_COLOR_PRIMARY_DARK,    // dark green
          themeDarker: '#004578',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'accenture') {

      loadTheme({
        palette: {
          themePrimary: '#A100FF',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#71afe5',
          themeSecondary: '#2b88d8',
          themeDarkAlt: '#095C2D', // dark green (button hover)
          themeDark: '#095C2D',    // dark green
          themeDarker: '#004578',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else if (theme === 'client') {

      loadTheme({
        palette: {
          themePrimary: '#2E8B57',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#71afe5',
          themeSecondary: '#2b88d8',
          themeDarkAlt: '#095C2D', // dark green (button hover)
          themeDark: '#095C2D',    // dark green
          themeDarker: '#004578',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    } else {

      loadTheme({
        palette: {
          themePrimary: '#FF5800',      // green
          themeLighterAlt: '#eff6fc',
          themeLighter: '#deecf9',
          themeLight: process.env.REACT_APP_WSP_COLOR_BACKGROUND,     // light gray loader background
          themeTertiary: '#71afe5',
          themeSecondary: '#2b88d8',
          themeDarkAlt: '#a73b00', // dark green (button hover)
          themeDark: '#a73b00',    // dark green
          themeDarker: '#004578',
          neutralLighterAlt: '#f8f8f8',
          neutralLighter: '#f4f4f4',
          neutralLight: '#eaeaea',
          neutralQuaternaryAlt: '#dadada',
          neutralQuaternary: '#d0d0d0',
          neutralTertiaryAlt: '#c8c8c8',
          neutralTertiary: '#c2c2c2',
          neutralSecondary: '#858585',
          neutralPrimaryAlt: '#4b4b4b',
          neutralPrimary: '#333333',
          neutralDark: '#272727',
          black: '#1d1d1d',
          white: '#ffffff'
        }
      });

    }

  }, [ theme ]);



  // scroll

  const [ scrollY, setScrollY ] = useState<number>(0);

  // useEffect(() => {

  //   const handleScroll = () => {
  //     if (window.scrollY > 0) {
  //       setScrollY(window.scrollY);
  //     } else {
  //       setScrollY(0);
  //     }
  //   }

  //   window.addEventListener('scroll', handleScroll);

  //   handleScroll();

  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);



  console.log(theme);



  if (window.location.href.indexOf('/sales/solution/screenshot/') > -1) {

    return (
      <>
        <WsScreenshot />
      </>
    );

  } else {


    // theme class

    const themeClass = [ 'ws-theme' ];

    if (theme === 'hp') {
      themeClass.push('ws-theme-hp');

    } else if (theme === 'accenture') {
      themeClass.push('ws-theme-accenture');

    } else if (theme === 'client') {
      themeClass.push('ws-theme-client');

    } else if (theme === 'hwb') {
      themeClass.push('ws-theme-hwb');

    } else if (theme === 'essex') {
      themeClass.push('ws-theme-essex');

    } else if (theme === 'nestle') {
      themeClass.push('ws-theme-nestle');

    } else if (theme === 'amadeus') {
      themeClass.push('ws-theme-amadeus');

    } else if (theme === 'deutschebank') {
      themeClass.push('ws-theme-deutschebank');

    } else if (theme === 'riverty') {
      themeClass.push('ws-theme-riverty');

    } else if (theme === 'marksandspencer') {
      themeClass.push('ws-theme-marksandspencer');

    } else {
      themeClass.push('ws-theme-avanade');
    }


    // app class

    const appClassList = [ 'App' ];

    if (scrollY > 54) {
      appClassList.push('wsp-header-out');
    }

    if (scrollY > 59) {
      appClassList.push('wsp-toast-fixed');
    }


    // console.log('!!!');
    // console.log(panelContext.getPanelContentType());


    // render

    return (
      <MsalProvider instance={pca}>

        <div className={ themeClass.join(' ') }>
          <div className={ appClassList.join(' ') }>

            <WsAppContext.Provider value={{ theme, setTheme, role, setRole }}>

              <AuthenticatedTemplate>
                <WsDeliverPortal />
              </AuthenticatedTemplate>

              <UnauthenticatedTemplate>
                {/* <BrowserRouter>
                  <Switch>
                    <Route path="/login" component={WsLoginPage} />
                    <Route path="/"      component={WsWelcomePage} />
                  </Switch>
                </BrowserRouter> */}
                {
                  loginClicked ? <WsLoginPage /> : <WsWelcomePage setLoginClicked={setLoginClicked} />
                }
              </UnauthenticatedTemplate>

              <div className="resolution-warning">
                The current browser windows is too small!<br />
                Please consider resizing to at least 990x400 pixels.
              </div>

              <footer className="footer">
                <div className="content has-text-centered">
                  <div>
                    <strong className='ws-hp-solutions'>Decode</strong> powered by <strong className="ws-accelerate">Avanade</strong> &copy; 2026
                    <hr style={{ width: '330px', margin: '5px auto 0px', height: '1px', backgroundColor: '#dad8d8' }} />
                    <a style={{ fontSize: '13px' }} href="https://avanade.sharepoint.com/sites/GlobalPrivacyStatement/SitePages/Global-Privacy-Statement-EN.aspx?web=1" target="_blank" rel="noreferrer">Privacy Statement</a>
                    <div style={{ fontSize: '13px' }}>v1.25</div>
                    {
                      process.env.NODE_ENV === 'development'
                      &&
                      <div>
                        {process.env.NODE_ENV}<br />
                        {process.env.REACT_APP_WSP_ENV}<br />
                        {process.env.REACT_APP_REDIRECT_URI}
                      </div>
                    }
                  </div>
                </div>
              </footer>

            </WsAppContext.Provider>

          </div>
        </div>

      </MsalProvider>
    );
  }
};




export {
  WsDeliverApp
};
